// src/components/common/CourseCard.jsx

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/api";
import { useAuth } from "../../contexts/AuthContext";
import { useCart } from "../../contexts/CartContext";
import BuyCourseModal from "../course/BuyCourseModal";

const BACKEND_BASE_URL = "https://imagensdaface.com.br";

// ============================
// FORMATADOR DE TEMPO
// ============================
function formatSeconds(seconds) {
  const total = Math.max(0, Number(seconds || 0));

  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  const pad = (n) => String(n).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

export default function CourseCard({ course }) {
  const { isAuthenticated } = useAuth();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const [access, setAccess] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const courseId = course.id;

  // ============================
  // VERIFICA ACESSO
  // ============================
  useEffect(() => {
    async function checkAccess() {
      if (!isAuthenticated) {
        setAccess("login");
        return;
      }

      try {
        const res = await api.get(`/courses/${courseId}/access`);
        setAccess(res.data.allowed ? "allowed" : "buy");
      } catch {
        setAccess("buy");
      }
    }

    checkAccess();
  }, [courseId, isAuthenticated]);

  // ============================
  // IMAGEM
  // ============================
  const imageUrl = course.cover_image_url
    ? course.cover_image_url.startsWith("http")
      ? course.cover_image_url
      : `${BACKEND_BASE_URL}${course.cover_image_url}`
    : "https://via.placeholder.com/400x200";

  // ============================
  // BOTÃO
  // ============================
  const renderButton = () => {
    if (access === "login") {
      return (
        <button
          onClick={() => navigate("/login")}
          className="bg-gray-800 text-white px-5 py-2 rounded-full w-full"
        >
          Entrar para acessar
        </button>
      );
    }

    if (access === "buy") {
      return (
        <button
          onClick={() => setShowModal(true)}
          className="bg-emerald-600 text-white px-5 py-2 rounded-full w-full hover:bg-emerald-700"
        >
          Comprar Curso
        </button>
      );
    }

    if (access === "allowed") {
      return (
        <Link
          to={`/cursos/${courseId}`}
          className="bg-indigo-600 text-white px-5 py-2 rounded-full w-full text-center hover:bg-indigo-700 block"
        >
          Acessar Curso
        </Link>
      );
    }

    return null;
  };

  return (
    <>
      {/* ================= CARD ================= */}
      <div className="bg-white rounded-xl shadow-xl overflow-hidden transition hover:scale-[1.02]">
        <img
          src={imageUrl}
          alt={course.title}
          className="w-full h-48 object-cover"
        />

        <div className="p-5">
          <h3 className="text-xl font-bold text-indigo-700 mb-2">
            {course.title}
          </h3>

          <p className="text-gray-600 text-sm mb-3">
            {course.description}
          </p>

          {/* ================= TEMPO ASSISTIDO ================= */}
          <p className="text-sm text-gray-500 mb-4">
            ⏱ Tempo assistido:
            <span className="ml-2 font-mono text-indigo-600">
              {formatSeconds(course.totalTimeSeconds)}
            </span>
          </p>

          {renderButton()}
        </div>
      </div>

      {/* ================= MODAL ================= */}
      {showModal && (
        <BuyCourseModal
          course={course}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
